import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminShell from './AdminShell';
import { api } from '../../lib/api';
import { FileText, ImageIcon, Mail, ArrowRight } from 'lucide-react';

const AdminDashboard = () => {
  const [stats, setStats] = useState({ posts: 0, images: 0, contacts: 0 });

  useEffect(() => {
    (async () => {
      try {
        const [posts, images, contacts] = await Promise.all([
          api.get('/admin/blog'),
          api.get('/images'),
          api.get('/admin/contacts'),
        ]);
        setStats({
          posts: posts.data.length,
          images: images.data.length,
          contacts: contacts.data.length,
        });
      } catch (e) {}
    })();
  }, []);

  const cards = [
    { to: '/admin/blog', icon: FileText, label: 'Blog posts', value: stats.posts, sub: 'Manage posts' },
    { to: '/admin/images', icon: ImageIcon, label: 'Images', value: stats.images, sub: 'Replace assets' },
    { to: '/admin/contacts', icon: Mail, label: 'Contact messages', value: stats.contacts, sub: 'View inbox' },
  ];

  return (
    <AdminShell title="Overview">
      <div className="grid md:grid-cols-3 gap-4">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Link
              key={c.to}
              to={c.to}
              className="bg-white rounded-2xl border border-[var(--line-2)] p-6 hover:border-ink transition-colors"
            >
              <Icon className="w-5 h-5 text-ink mb-4" />
              <div className="text-3xl font-semibold text-ink">{c.value}</div>
              <div className="text-sm text-ink-3 mt-1">{c.label}</div>
              <div className="text-xs text-ink-2 mt-3 inline-flex items-center gap-1">
                {c.sub} <ArrowRight className="w-3 h-3" />
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-8 bg-white rounded-2xl border border-[var(--line-2)] p-6">
        <h3 className="text-base font-semibold text-ink mb-2">Getting started</h3>
        <ul className="text-sm text-ink-2 space-y-1.5">
          <li>• Post a new blog article from <strong>Blog posts</strong>.</li>
          <li>• Replace hero and product screenshots from <strong>Images</strong>.</li>
          <li>• Contact form submissions are queued for delivery to sales@briefingiq.com.</li>
        </ul>
      </div>
    </AdminShell>
  );
};

export default AdminDashboard;
